import React from 'react';
var SSRContext = /*#__PURE__*/React.createContext();
export default SSRContext;